import { useState } from "react"
import { Alert, Stack } from "@mui/material"

import { LocalizedStrict } from "../../../../../../modules/localization/components/AppLocalized"
import { useRemovedServices } from "./RemovedServicesContext"

export function RemovedServicesNotification(): React.ReactElement | null {
    const { removedServices } = useRemovedServices()
    const [dismissed, setDismissed] = useState<Set<number>>(new Set())

    const visible = removedServices.filter((s) => !dismissed.has(s.id))
    if (!visible.length) return null

    const handleClose = (id: number) => setDismissed((prev) => new Set(prev).add(id))

    return (
        <Stack gap=".5rem">
            {visible.map(({ id, name }) => (
                <LocalizedStrict key={id} id="create-order-extra-services-removed-notification" vars={{ name }}>
                    <Alert severity="error" onClose={() => handleClose(id)}>
                        {`"${name}" is no longer available and has been removed from your cart.`}
                    </Alert>
                </LocalizedStrict>
            ))}
        </Stack>
    )
}

